import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { StarRounded, Link } from "@mui/icons-material"
import { TableRow, TableCell } from "@mui/material"
import { percentageFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"

class DetailRow extends Component {
  onClick = () => {
    const { value, openFactorProfile } = this.props
    openFactorProfile(value.id)
  }

  render() {
    const { value, index } = this.props

    return <TableRow className={classNames("detail-row", { favorite: value.favorite })}>
      <TableCell component="th" scope="row" className="name" style={index === 0 ? { color: value.color, textTransform: "uppercase" } : undefined}>
        <div className="factor-link-wrapper">
          <StarRounded className="star-icon" />
          {value.type === "factors" && !getFactorDisabled(value.category)
            ? <a onClick={this.onClick}>{value.label}{!!value.secondaryLabel && <span className="secondary"> - {value.secondaryLabel}</span>}<Link className="icon" /></a>
            : <span>{value.label}{!!value.secondaryLabel && <span className="secondary">&nbsp;- {value.secondaryLabel}</span>}</span>}
        </div>
      </TableCell>
      <TableCell align="right" style={index === 0 ? { color: value.color } : undefined}>{percentageFormatter(value.value)}</TableCell>
    </TableRow>
  }
}

DetailRow.propTypes = {
  value: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
}

export default DetailRow
